import React from 'react';
import '../../styles/landing.css';
import Header from '../../components/Landing/Header';
import Hero from '../../components/Landing/Hero';
import StatsBar from '../../components/Landing/StatsBar';
import About from '../../components/Landing/About';
import Segments from '../../components/Landing/Segments';
import Solutions from '../../components/Landing/Solutions';
import CyberSensei from '../../components/Landing/CyberSensei';
import Testimonials from '../../components/Landing/Testimonials';
import Media from '../../components/Landing/Media';
import CallToAction from '../../components/Landing/CallToAction';
import Footer from '../../components/Landing/Footer';
import FloatingWhatsApp from '../../components/Landing/FloatingWhatsApp';

export default function LandingPage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <StatsBar />
        <About />
        <Segments />
        <Solutions />
        <CyberSensei />
        <Testimonials />
        <Media />
        <CallToAction />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
}
